export const NotificationDefaultDataset = {
  langMap: [
    {
      langCode: "en",
      title: "",
      summary: "",
      mainContent: [
        {
          displayOrder: 1,
          text: "",
          imageIds: [],
        },
      ],
    },
  ],
};

export const newNotificationSectionTemplate = {
  title: "",
  summary: "",
  mainContent: [
    {
      displayOrder: 1,
      text: "",
      imageIds: [],
    },
  ],
};
